import React from 'react';
import { Link } from 'react-router-dom';

import { useArchivedEventState } from '@atlas/core';
import { Button, EmptyStateView, Label } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';
import Header from 'components/Header/Header';
import DetailsEventHeader from 'components/Pages/Details/DetailsEventHeader';

import { defaultRoutes } from '../../MainRouter/constants';

const DetailsEventRedirectPage = props => {
  const { detailsEventClass, isIframe, onHidePopup, suspended } = props;

  const event = useArchivedEventState();
  const { sportLive } = defaultRoutes;

  return (
    <ModalPortal backdropOff className="popup-details-event">
      <div className="detail-page-with-header">
        <Header isDetailPage isIframe={isIframe} />
        <div className={detailsEventClass}>
          <DetailsEventHeader event={event} isResults suspended={suspended} />

          <div className="event-end-notification">
            <EmptyStateView
              description="Bets on this event will not be accepted."
              title="The event is finished."
            >
              <div className="sticky-bottom-buttons-container column">
                <Button
                  className="btn big secondary"
                  label="To match results"
                  onClick={onHidePopup}
                />
                <Link className="btn big primary" to={sportLive}>
                  <Label message="Back to Live event list" />
                </Link>
              </div>
            </EmptyStateView>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default DetailsEventRedirectPage;
